(function() {
    'use strict';

    let VipCtrl = function(
        $scope,
        $state,
        $stateParams,
        CONSTANTS,
        messaggiFctr,
        vipService,
        gestioneUtenteService,
        invioCredenzialiService,
        $uibModal
    ) {
        this.vipService = vipService;
        this.invioCredenzialiService = invioCredenzialiService;
        this.vipService.reset();

        this.init = () => {
            this.loaded = (this.vipService.datiMito && this.gestioneUtenteService.datiMito?.credenzialiVip) || false;
            if (!this.loaded) {
                this.ricaricaUtenzaMito($stateParams.codiceUtente);
            } else {
                this.invioCredenzialiService.datiMito = this.vipService.datiMito;
            }
        };

        this.ricaricaUtenzaMito = (codiceUtente) => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            gestioneUtenteService.getDatiMito(codiceUtente)
                .then(
                    (resp) => {
                        if (messaggiFctr.processaResponse(resp)) {
                            return;
                        }

                        let dtoOutput = resp.data.result;
                        this.vipService.datiMito = dtoOutput.utenzaMito;
                        this.invioCredenzialiService.datiMito = dtoOutput.utenzaMito;
                        gestioneUtenteService.setUtenzaMito(dtoOutput.utenzaMito);
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(
                    () => {
                        this.loading--;
                        this.loaded = true;
                    }
                );
        };

        this.vipAttivo = () => {
            let flag = gestioneUtenteService.datiMito.credenzialiVip && gestioneUtenteService.datiMito.credenzialiVip.some(
                (cred) => cred.statoAbilitato === 'ENABLED'
            );
            return flag || false;
        };

        this.indietro = () => {
            $state.go('gestioneUtenteMito', $stateParams);
        };

        this.autenticaUtente = () => {
            let template =
            '<div class="ng-modal-overlay"></div>' +
            '<div class="row ng-modal-dialog">' +
                '<div class="col-md-12 ng-modal-dialog-content" style="margin-bottom:10px; margin-top:10px;">' +
                    '<h2 class="nome-dettaglio">AUTENTICA UTENTE VIP</h2>' +
                    '<p>Inserire il codice OTP per procedere con l\'autenticazione:</p>' +
                    '<label for="otp" ng-bind="codiceUtente + \':\'"></label>' +
                    '<input type="text" name="otp" class="form-control" ng-model="otp" />' +
                '</div>' +
                '<div class="modal-footer">' +
                    '<button type="button" class="btn btn-default bfd-cancel" ng-click="cancel()">Indietro</button>' +
                    '<button type="button" class="btn btn-default bfd-cancel" ng-click="ok()">Autentica</button>' +
                '</div>' +
            '</div>';
            $uibModal.open({
                template: template,
                size: 'small',
                backdrop: 'static',
                controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                    $scope.codiceUtente = $stateParams.codiceUtente;
                    
                    // Richiamato quando si chiude il popup
                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };

                    $scope.ok = function () {
                        $uibModalInstance.close([$scope.codiceUtente, this.otp]);
                    };
                }]
            }).result.then(
                (params) => {
                    if (params) {
                        let codiceUtente = params[0];
                        let otp = params[1];
                        this.loading++;

                        this.vipService.autentica(codiceUtente, otp)
                        .then(
                            (response) => {
                                if (messaggiFctr.processaResponse(response)) {
                                    return;
                                }
        
                                if (response.data.result) {
                                    messaggiFctr.addMessage({
                                        "type": 'E',
                                        "message": 'Autenticazione fallita: ' + response.data.result
                                    });
                                    return;
                                }
                                messaggiFctr.addSuccessMessage({
                                    "type": 'I',
                                    "message": 'Autenticazione effettuata con successo'
                                });
                            },
                            (reason) => {
                                messaggiFctr.processaResponse(reason);
                            }
                        )
                        .finally(
                            () => this.loading--
                        );
                    }
                }
            );
        };

        this.inviaPush = () => {
            this.loading++;
            this.vipService.inviaPush($stateParams.codiceUtente)
                .then(
                    (response) => {
                        if (messaggiFctr.processaResponse(response)) {
                            return;
                        }

                        if (response.data.result) {
                            messaggiFctr.addMessage({
                                "type": 'E',
                                "message": 'Notifica push fallita: ' + response.data.result
                            });
                            return;
                        }
                        messaggiFctr.addSuccessMessage({
                            "type": 'I',
                            "message": 'Notifica push effettuata con successo'
                        });
                    },
                    (reason) => {
                        messaggiFctr.processaResponse(reason);
                    }
                )
                .finally(
                    () => this.loading--
                );
        };

        this.visualizzaStoricoUtenteSymantec = () => {
            this.invioCredenzialiService.modalita = 'StoricoUtenteSymantec';
            $uibModal.open({
                templateUrl: CONSTANTS.BASE_ROOT + 'modals/storicoDinamico/storicoDinamico.modal.html',
                controller: 'MitomStoricoDinamicoController',
                controllerAs: 'storicoCtrl',
                size: 'document'
            });
        };

        this.visualizzaStoricoGlobale = () => {
            this.invioCredenzialiService.modalita = 'StoricoGlobaleSymantec';
            $uibModal.open({
                templateUrl: CONSTANTS.BASE_ROOT + 'modals/storicoDinamico/storicoDinamico.modal.html',
                controller: 'MitomStoricoDinamicoController',
                controllerAs: 'storicoCtrl',
                size: 'document'
            });
        };

        this.visualizzaStoricoSms = () => {
            this.invioCredenzialiService.modalita = 'StoricoSmsOtp';
            $uibModal.open({
                templateUrl: CONSTANTS.BASE_ROOT + 'modals/storicoDinamico/storicoDinamico.modal.html',
                controller: 'MitomStoricoDinamicoController',
                controllerAs: 'storicoCtrl',
                size: 'document'
            });
        };

        this.init();
    };

    VipCtrl.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        'Mitom_CONSTANTS',
        'MitomMessaggiFctr',
        'MitomVipService',
        'MitomGestioneUtenteService',
        'MitomInvioCredenzialiService',
        '$uibModal'
    ];

    let TemplateUrl = function(CONSTANTS) {
        return (
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'mitoman-vip/vip.component.html'
        );
    };
    TemplateUrl.$inject = ['Mitom_CONSTANTS'];

    let VipComponent = {
        controller: VipCtrl,
        controllerAs: 'vipCtrl',
        templateUrl: TemplateUrl
    };

    angular
        .module('cbl.mitomanager.wa')
        .component('mitomVip', VipComponent);
})();